module.exports = __webpack_public_path__ + "9a0f93230d75891ab1d11a530f126e4a.pdf";